"use strict";
/**
 * Copyright © 2019 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asEditableProduct = exports.ProductClean = exports.Product = void 0;
/* eslint-disable jsx-a11y/anchor-is-valid */

var react_1 = __importDefault(require("react"));

var lodash_1 = require("lodash");

var fclasses_1 = require("@bodiless/fclasses");

var components_1 = require("@bodiless/components");

var components_ui_1 = require("@bodiless/components-ui");

var core_1 = require("@bodiless/core");

var bv_1 = require("@bodiless/bv");

var ProductComponentStart = {
  Wrapper: fclasses_1.Div,
  ImageWrapper: fclasses_1.Div,
  ImageLink: fclasses_1.A,
  Image: fclasses_1.Img,
  ContentWrapper: fclasses_1.Div,
  TitleLink: fclasses_1.A,
  Title: fclasses_1.H2,
  BvReviewLink: fclasses_1.A,
  BvReview: fclasses_1.Div,
  Body: fclasses_1.Div
};

var ProductBase = function ProductBase(_a) {
  var components = _a.components;
  var Wrapper = components.Wrapper,
      ImageWrapper = components.ImageWrapper,
      Image = components.Image,
      ImageLink = components.ImageLink,
      ContentWrapper = components.ContentWrapper,
      TitleLink = components.TitleLink,
      Title = components.Title,
      BvReview = components.BvReview,
      BvReviewLink = components.BvReviewLink,
      Body = components.Body;
  return react_1.default.createElement(Wrapper, null, react_1.default.createElement(ImageWrapper, null, react_1.default.createElement(ImageLink, null, react_1.default.createElement(Image, null))), react_1.default.createElement(ContentWrapper, null, react_1.default.createElement(TitleLink, null, react_1.default.createElement(Title, null)), react_1.default.createElement(BvReviewLink, null, react_1.default.createElement(BvReview, null)), react_1.default.createElement(Body, null)));
};

var ProductClean = lodash_1.flow(fclasses_1.designable(ProductComponentStart, 'Product'), core_1.withNode)(ProductBase);
exports.ProductClean = ProductClean;
var asEditableProduct = fclasses_1.withDesign({
  Image: components_ui_1.asBodilessImage('image'),
  ImageLink: components_1.asBodilessLink('cta'),
  TitleLink: components_1.asBodilessLink('cta'),
  Title: components_1.asEditable('title', 'Product Title Text'),
  BvReviewLink: components_1.asBodilessLink('cta'),
  BvReview: function BvReview() {
    return bv_1.BVInlineRatings;
  },
  Body: components_1.asEditable('body', 'Product Body Text')
});
exports.asEditableProduct = asEditableProduct;
var Product = asEditableProduct(ProductClean);
exports.Product = Product;
exports.default = Product;